export const mockFlights = [
  {
    id: 'fl-001',
    airline: 'Emirates',
    airlineCode: 'EK',
    flightNumber: 'EK 203',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '23:15',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '19:25',
      date: '2026-04-16',
    },
    duration: '12h 10m',
    stops: 0,
    stopsInfo: 'Nonstop',
    price: 1245,
    cabin: 'Economy',
    amenities: ['wifi', 'restaurant', 'power', 'movie', 'airline_seat_recline_extra'],
  },
  {
    id: 'fl-002',
    airline: 'Qatar Airways',
    airlineCode: 'QR',
    flightNumber: 'QR 702',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '20:00',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '18:40',
      date: '2026-04-16',
    },
    duration: '14h 40m',
    stops: 1,
    stopsInfo: '1 stop (DOH)',
    price: 987,
    cabin: 'Economy',
    amenities: ['wifi', 'restaurant', 'power', 'movie'],
  },
  {
    id: 'fl-003',
    airline: 'Etihad',
    airlineCode: 'EY',
    flightNumber: 'EY 102',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '02:30',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '01:05',
      date: '2026-04-16',
    },
    duration: '14h 35m',
    stops: 1,
    stopsInfo: '1 stop (AUH)',
    price: 1050,
    cabin: 'Economy',
    amenities: ['wifi', 'restaurant', 'power', 'movie', 'airline_seat_recline_extra'],
  },
  {
    id: 'fl-004',
    airline: 'Turkish Airlines',
    airlineCode: 'TK',
    flightNumber: 'TK 2',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '01:00',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '04:15',
      date: '2026-04-16',
    },
    duration: '19h 15m',
    stops: 1,
    stopsInfo: '1 stop (IST)',
    price: 842,
    cabin: 'Economy',
    amenities: ['restaurant', 'movie', 'power'],
  },
  {
    id: 'fl-005',
    airline: 'Lufthansa',
    airlineCode: 'LH',
    flightNumber: 'LH 405',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '17:50',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '21:30',
      date: '2026-04-16',
    },
    duration: '19h 40m',
    stops: 1,
    stopsInfo: '1 stop (FRA)',
    price: 915,
    cabin: 'Economy',
    amenities: ['wifi', 'restaurant', 'power', 'movie'],
  },
  {
    id: 'fl-006',
    airline: 'British Airways',
    airlineCode: 'BA',
    flightNumber: 'BA 178',
    departure: {
      airport: 'JFK',
      city: 'New York',
      time: '19:00',
      date: '2026-04-15',
    },
    arrival: {
      airport: 'DXB',
      city: 'Dubai',
      time: '22:50',
      date: '2026-04-16',
    },
    duration: '19h 50m',
    stops: 1,
    stopsInfo: '1 stop (LHR)',
    price: 978,
    cabin: 'Economy',
    amenities: ['wifi', 'restaurant', 'movie'],
  },
];

export const mockDestinations = [
  {
    id: 'dest-001',
    name: 'Dubai',
    country: 'UAE',
    code: 'DXB',
    startingPrice: 987,
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400&q=80',
    color: 'from-amber-600/80 to-amber-900/80',
  },
  {
    id: 'dest-002',
    name: 'Tokyo',
    country: 'Japan',
    code: 'NRT',
    startingPrice: 1120,
    image: 'https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=400&q=80',
    color: 'from-pink-600/80 to-pink-900/80',
  },
  {
    id: 'dest-003',
    name: 'Barcelona',
    country: 'Spain',
    code: 'BCN',
    startingPrice: 645,
    image: 'https://images.unsplash.com/photo-1583422409516-2895a77efded?w=400&q=80',
    color: 'from-orange-600/80 to-orange-900/80',
  },
  {
    id: 'dest-004',
    name: 'Maldives',
    country: 'Maldives',
    code: 'MLE',
    startingPrice: 1450,
    image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=400&q=80',
    color: 'from-cyan-600/80 to-cyan-900/80',
  },
  {
    id: 'dest-005',
    name: 'London',
    country: 'United Kingdom',
    code: 'LHR',
    startingPrice: 580,
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400&q=80',
    color: 'from-slate-600/80 to-slate-900/80',
  },
  {
    id: 'dest-006',
    name: 'Singapore',
    country: 'Singapore',
    code: 'SIN',
    startingPrice: 890,
    image: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=400&q=80',
    color: 'from-emerald-600/80 to-emerald-900/80',
  },
];
